import type { Configuration } from '@repo/api-gw-sdk';
import { GetAccountsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/account-logo';

export const accountLogo = (httpClient: HttpClient, config: Configuration) => {
  const getAccountsApi = new GetAccountsApi(config);

  return {
    useLogo: () =>
      httpClient.executeWithConfig(
        async () => {
          try {
            const blob = await getAccountsApi.getAccountLogo();
            return URL.createObjectURL(blob);
          } catch {
            // Logo is cosmetic; 404 (no logo set) is expected, and any other
            // error should fall back to the placeholder icon silently.
            return null;
          }
        },
        baseUrl,
        'get-account-logo',
        {
          revalidateOnFocus: false,
          revalidateOnReconnect: false,
          revalidateIfStale: false,
          shouldRetryOnError: false,
        }
      ),
  };
};
